import { observable, action, reaction } from 'mobx';
import { isSome } from 'core/utils';
import { extractAccessors } from 'core/utils/cloneAccessors';

class FilterParams {
    @observable accessor pageNumber;
    @observable accessor pageSize;
    @observable accessor orderBy;
    @observable accessor orderDirection;
    @observable accessor embed;
    @observable accessor search;
    @observable accessor fields;

    constructor() {

        this.reset();

        reaction(
            () => this.search,
            search => {
                this.search =
                    isSome(search) && search !== '' ? search : undefined;
            }
        );
    }

    // Deconstruct interface: controls how this filter is extracted into a plain
    // object by cloneAccessors / deepCloneAccessors / queryUtility.plainFilter.
    // Uses the non-delegating extractAccessors primitive (the default accessor
    // walk); override here to customize the deconstruction (e.g. drop transient
    // fields, rename keys) if ever needed.
    deconstructAccessors() {
        return extractAccessors(this);
    }

    @action
    reset(differentDefault) {
        this.pageNumber = 1;
        if(differentDefault==undefined)
            this.pageSize = 25;
        else 
            this.pageSize = differentDefault;
        this.orderBy = null;
        this.orderDirection = null;
        this.embed = null;
        this.search = null;
        this.fields = null;
    }

    @action
    set(key, value) {
        this[key] = value;
    }

    @action
    toggle(key) {
        const property = this[key];
        const evalValue = property ? eval(property) : false;
        if (typeof evalValue === 'boolean') {
            this[key] = !property;
        }
    }
}

export default FilterParams;
